export default __webpack_public_path__ + "static/media/Geneva-Normal.10241a7f.ttf";